import { useAddToast } from '@/components/base/toast/use-toast';
import RichTextContent from '@/features/info-top-banner/components/rich-text-content';
import { ensureHttpsProtocol } from '@/features/info-top-banner/utils/ensure-https-protocol';
import { Link } from '@/navigation';
import { useTranslations } from 'next-intl';

interface Props {
  content: string;
  promoCode?: string;
  url?: string | undefined;
}

export const TextContent = ({ content, promoCode, url }: Props) => {
  const t = useTranslations('navigation');

  const addToast = useAddToast();

  const copyPromoCode = () => {
    if (!promoCode) return;

    navigator.clipboard.writeText(promoCode);
    addToast({
      type: 'success',
      content: t('copy_promo_code'),
      duration: 3000,
    });
  };
  const httpUrl = ensureHttpsProtocol(url || '');

  return (
    <div className="mx-auto flex flex-wrap items-center gap-5">
      {url && !content.includes('href') ? (
        <Link
          target="_blank"
          href={httpUrl}
          className="underline-offset-4 hover:underline"
        >
          <RichTextContent content={content} />
        </Link>
      ) : (
        <RichTextContent content={content} />
      )}
      {promoCode && (
        <p
          className="cursor-copy rounded-xs border border-white/75 border-dashed px-xxs text-body"
          onClick={copyPromoCode}
        >
          {promoCode}
        </p>
      )}
    </div>
  );
};
